export default __webpack_public_path__ + "static/media/slip.9471bb79.svg";